import { render } from "./document-icon.svg?vue&type=template&id=c2f8beee"
import script from "./document-icon.svg?vue&type=script&lang=js"
export * from "./document-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src806/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__